import { gql } from '@apollo/client';

const ASSIGN_LICENSE_TO_USER = gql`
  mutation assignLicenseToUser($user: AssignUserLicenseInput!) {
    assignLicenseToUser(user: $user) {
      Success
      Message
    }
  }
`;

export default ASSIGN_LICENSE_TO_USER;
